export const deleteAuthToken = () => {
  localStorage.removeItem("authInfo");
};
